import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { VENUE_LISTING_URL } from '../Header/constants';
import './VenuesBanner.css';

const VenuesBanner = ({ variant = 'default' }) => {
  const setCursorStroke = useCallback((event) => {
    const el = event.currentTarget;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--glow-x', `${event.clientX - rect.left}px`);
    el.style.setProperty('--glow-y', `${event.clientY - rect.top}px`);
  }, []);

  return (
    <div
      className={`venues-banner${variant === 'landing' ? ' venues-banner--landing' : ''}`}
      onMouseMove={setCursorStroke}
    >
      <div className="venues-banner-copy">
        <h3 className="venues-banner-title">Built for venues that mean business</h3>
        <p>
          <span>
            These venues chose Occasia to manage their bookings and grow their
            business.
          </span>
          <br />
          <span>
            If you run a space worth booking,
            <br className="venues-banner-br-mobile" /> we&apos;d like to work with
            you.
          </span>
        </p>
        <div className="venues-banner-actions">
          <a
            href={VENUE_LISTING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="venues-banner-cta-list"
          >
            List your venue
          </a>
          <Link to="/onboard?persona=venues" className="venues-banner-cta-secondary">
            Learn more
          </Link>
        </div>
      </div>
      <img
        className="venues-banner-art"
        src="/manual-booking/list-venue-graphic.png"
        alt=""
        aria-hidden
      />
      <img
        className="venues-banner-corner"
        src="/manual-booking/venues-banner-corner.png"
        alt=""
        aria-hidden
      />
    </div>
  );
};

export default VenuesBanner;
